<template>
    <LayoutHelp
        :title="$t('helpPage.title')"
        :description="$t('helpPage.description')">
        <template v-slot:searchbox>
            <SearchBox />
        </template>
        <template v-slot:content>
            <LinkList
                :headingText="$t('helpPage.commonPage.heading')"
                :returnText="$t('helpPage.showAll')"
                :returnLink="$router.resolve(localeRoute({name: 'helpListCommon'})).href"
                :links="commonLinks"
                :showMoreButton="true" />

            <LinkList
                :headingText="$t('helpPage.editPage.heading')"
                :returnText="$t('helpPage.showAll')"
                :returnLink="$router.resolve(localeRoute({name: 'helpListEdit'})).href"
                :links="editingLinks"
                :showMoreButton="true" />

            <LinkList
                :headingText="$t('helpPage.cadastralPage.heading')"
                :returnText="$t('helpPage.showAll')"
                :returnLink="$router.resolve(localeRoute({name: 'helpListCadastral'})).href"
                :links="cadastralLinks"
                :showMoreButton="true" />
        </template>
    </LayoutHelp>
</template>

<script>

import { setPageTitle, setMeta, getPageTitle, getPageMetaDescription } from '@/utils/meta'
import webCMS from '@/services/WebCMS';
import SearchBox from '@/components/help/search';
import LinkList from '@/components/help/linkList';
import LayoutHelp from '@/components/layouts/Help';

export default {
    components: {
        SearchBox,
        LinkList,
        LayoutHelp
    },
    created: function() {
        setPageTitle(getPageTitle(this.$route));
        setMeta("description", getPageMetaDescription(this.$route));
        this.loadCommonHelpLinks();
        this.loadCadastralHelpLinks();
        this.loadEditingHelpLinks();
    },
    data() {
        return {
            commonLinks: [],
            cadastralLinks: [],
            editingLinks: [],
        };
    },
    methods: {
        loadCommonHelpLinks() {
            webCMS.getLinksByTag(this.axios, {tag: "HELP_PAGE_COMMON"})
                .then(res => {
                    this.commonLinks = res;
                });
        },
        loadCadastralHelpLinks() {
            webCMS.getLinksByTag(this.axios, {tag: "HELP_PAGE_CADASTRAL_INFO"})
                .then(res => {
                    this.cadastralLinks = res;
                });
        },
        loadEditingHelpLinks() {
            webCMS.getLinksByTag(this.axios, {tag: "HELP_PAGE_EDITING"})
                .then(res => {
                    this.editingLinks = res;
                });
        }
    }
}
</script>


<style lang="scss" scoped>
</style>
